<template>
	<div>
		<slot name="label">
			<div v-if="label" class="tw-pb-1.5 tw-font-medium tw-text-gray-600">
				<span>{{ label }}</span>
				<span v-if="props.rules.includes('required')" class="tw-text-error-400">*</span>
			</div>
		</slot>
		<div style="direction: ltr">
			<VueTelInput
				ref="phoneInput"
				class="tw-px-2.5 tw-py-1.5 tw-bg-white"
				style="border-color: rgb(208 213 221 / 1); border-radius: 0.5rem"
				v-model="inputModel"
				mode="international"
				showDialCodeInList
				:inputOptions="{ placeholder: '', showDialCode: true }"
				:defaultCountry="966"
				:autoFormat="false"
				@validate="handleValidate"
				@country-changed="handleCountryChange"
			/>
		</div>
		<div class="tw-pt-1 tw-text-sm" style="min-height: 20px">
			<div v-if="!errorMessage" class="tw-text-gray-600">
				{{ hint }}
			</div>
			<div v-if="errorMessage" class="tw-text-error-500">
				{{ errorMessage }}
			</div>
		</div>
	</div>
</template>

<script setup>
import 'vue-tel-input/vue-tel-input.css';
import { VueTelInput } from 'vue-tel-input';
import { computed } from 'vue';
import { ref } from 'vue';
import { toRefs } from 'vue';
import { useFieldValidation } from '../../utils/forms';
import { useI18n } from 'vue-i18n';

const props = defineProps({
	modelValue: {},
	label: {
		type: String,
		default: '',
	},
	placeholder: {
		type: String,
		default: '',
	},
	hint: {
		type: String,
		default: '',
	},
	disabled: {
		type: Boolean,
		default: false,
	},
	rules: {
		type: Array,
		default: () => [],
	},
	allocateBottomSpace: {
		type: Boolean,
		default: false,
	},
});

const { rules } = toRefs(props);
const { t } = useI18n();

let phoneInput = ref(null);
let valid = ref(false);

const emit = defineEmits(['update:modelValue']);

const emitModel = (val) => {
	emit('update:modelValue', val);
};

const inputModel = computed({
	get() {
		return props.modelValue ? `+${props.modelValue}` : '';
	},
	set: (val) => emitModel(val.replace('+', '')),
});

const rulesList = computed(() => {
	return [...rules.value, () => valid.value || t('validators.is-phone-number-with-country')];
});

const { errorMessage, resetErrorMessage } = useFieldValidation(
	() => props.modelValue,
	() => rulesList.value,
);

const handleValidate = (phoneObject) => {
	valid.value = phoneObject.valid;
};
const handleCountryChange = (countryObject) => {
	const fromSameCountry = props.modelValue.startsWith(countryObject.dialCode);

	if (!fromSameCountry) {
		inputModel.value = countryObject.dialCode;
	}
};

defineExpose({
	resetErrorMessage,
});
</script>
